<script>
import ServicesMixin from "@components/services/mixin";
import Mixin from "@utilities/mixin";
import ServicesTable from "@components/services/ServicesTable.vue";

export default {
  name: "ServicesMain",
  components: {ServicesTable},
  mixins: [Mixin, ServicesMixin],
  data() {
    const now = new Date();
    return {
      showButtons: false,
      dateRange: [now],
      selectedShop: parseInt(sessionStorage.getItem('sbShopId')),
    }
  },
  computed: {
    transactions() {
      return this.$store.state.transactions;
    },
    techs() {
      return this.$store.state.techs;
    },
    currentTech() {
      if (!isAdmin) {
        const current = this.techs.find(i => i.user_id === this.user.id);
        if (current) {
          this.selectedShop = current.shop_id;
        }
      }
    },
    shops() {
      return this.$store.state.shops;
    },
  },
  methods: {
    getFilteredTxns() {
      this.getTransactions(this.dateRange[0], this.dateRange[1], this.selectedShop);
    },
    refresh() {
      setTimeout(() => {
        this.getFilteredTxns();
      }, 500);
    },
  },
  created() {
    this.getFilteredTxns();
    this.getCurrentUser();
    this.getTechs();
    this.getShops();
  }
}
</script>

<template>
  <div class="flex flex-col gap-0 w-full">
    <Toolbar class="mt-0">
      <template #start>
        <div class="flex gap-4">
          <DatePicker v-model="dateRange" selectionMode="range" :manualInput="false"/>
          <Select v-model="selectedShop"
                  :options="shops"
                  showClear
                  optionLabel="name"
                  optionValue="id"
                  placeholder="All Shops"/>
          <Button @click="getFilteredTxns" class="me-2" icon="pi pi-search"/>
        </div>
      </template>
    </Toolbar>
    <div class="flex w-full">
      <ServicesTable @update="refresh" :txns="transactions" :tech-drops="techs" :shops="shops"/>
    </div>
  </div>
</template>
